import {type RefObject} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {queryParams} from '@dms/shared';

import {useOnMount, useQueryState} from 'shared/web';

interface OpenJobDetailProps {
  jobIds: string[];
  knownJobIdsRef: RefObject<Set<string> | null>;
}

export function OpenJobDetail(props: OpenJobDetailProps) {
  const [, setOpenJobId] = useQueryState(queryParams.SERVICE_CASE_OPEN_JOB_ID);
  const knownJobIdsRef = props.knownJobIdsRef;

  useOnMount(() => {
    const currentJobIds = new Set(props.jobIds);
    const knownJobIds = knownJobIdsRef.current;

    knownJobIdsRef.current = currentJobIds;

    if (knownJobIds === null) {
      const firstJobId = props.jobIds[0];

      if (currentJobIds.size === 1 && isNotNilOrEmpty(firstJobId)) {
        setOpenJobId(firstJobId);
      }

      return;
    }

    const newJobIds = props.jobIds.filter((jobId) => !knownJobIds.has(jobId));
    const lastAddedJobId = newJobIds[newJobIds.length - 1];

    if (isNotNilOrEmpty(lastAddedJobId)) {
      setOpenJobId(lastAddedJobId);
    }
  });

  return null;
}
